import { cn } from '@chessmate/ui';
import type { GameEntry } from '../lib/games-catalog.js';

/**
 * A decorative page background tinted by the chosen game: a soft gradient that fades to the page
 * colour, a large faint symbol in a corner, and, once a game has a cover picture, that picture blurred
 * and washed out behind it. It is fixed and behind the content (`ScreenLayout` isolates the stacking
 * context), ignores the pointer, and is hidden from screen readers. Text never sits straight on the
 * saturated part: the screens put it on a translucent panel, which keeps AA contrast.
 */
export function GameBackdrop({ game }: { game: GameEntry }) {
  return (
    <div aria-hidden="true" data-testid="game-backdrop" data-game={game.id} className="pointer-events-none fixed inset-0 -z-10 overflow-hidden">
      <div className={cn('absolute inset-0 bg-gradient-to-b dark:opacity-40', game.backdrop)} />
      {game.cover && (
        <img src={game.cover} alt="" className="absolute inset-0 size-full scale-110 object-cover opacity-30 blur-md dark:opacity-15" />
      )}
      <span className="absolute -right-10 -top-12 select-none text-[22rem] leading-none text-ink/10 dark:text-cream/10">{game.glyph}</span>
    </div>
  );
}
